import { call, put, takeLatest } from 'redux-saga/effects';

import { MealPlanResponse, MealResponse } from 'api/components/Nutrition';

import { handleErrorAction } from '../errors/actions';
import { notifyError } from '../notifications/actions';

import {
    getMealById as getMealByIdAction,
    getMealPlan as getMealPlanAction,
    setLoadingState,
    setMeal,
    setMealPlan,
} from './actions';
import { GET_MEAL_BY_ID, GET_MEAL_PLAN } from './actionTypes';

import api from '@/api';

function* getMealPlan({
    payload: { date },
}: ReturnType<typeof getMealPlanAction>): Generator<unknown, void, MealPlanResponse> {
    try {
        yield put(setLoadingState(true));
        const response = yield call(api.nutrition.getMealPlan, date);

        yield put(setLoadingState(false));
        yield put(setMealPlan(response));
    } catch (error) {
        yield put(setLoadingState(false));
        yield put(handleErrorAction(error));
        yield put(notifyError('Failed to load meal plan. Please try again later.'));
    }
}

function* getMealById({ payload }: ReturnType<typeof getMealByIdAction>): Generator<unknown, void, MealResponse> {
    const { mealId } = payload;

    try {
        yield put(setLoadingState(true));
        const response = yield call(api.nutrition.getMealById, mealId);

        yield put(setLoadingState(false));
        yield put(setMeal(response));
    } catch (error) {
        yield put(setLoadingState(false));
        yield put(handleErrorAction(error));
        yield put(notifyError('Failed to load meal details. Please try again later.'));
    }
}

export default function* nutritionSaga() {
    yield takeLatest(GET_MEAL_PLAN, getMealPlan);
    yield takeLatest(GET_MEAL_BY_ID, getMealById);
}
